module.exports = [
	"Anyone adjusts their uniform",
	"Anyone announces a phaser setting, 2 drinks",
	"Anyone falls down a hole, 2 drinks",
	"Anyone is thrown from their terminal in battle or otherwise",
	"Anyone plays poker",
	"Anyone says \"Containment Leak\"",
	"Anyone says \"Evasive maneuvers\"",
	"Anyone says \"Jean Luc\"",
	"Anyone says \"Level 3 Diagnostic\"",
	"Anyone says \"Maximum Warp\"",
	"Anyone says \"Red Alert\"",
	"Anyone says \"Energize\"",
	"Anyone says \"Engage\"",
	"Barclay appears in the episode, 2 drinks",
	"Data doesn't understand a colloquialism",
	"Data says \"Second Officer's Log\", 2 drinks",
	"Geordi is next to Data",
	"Guinan serves a drink and / or gives advice about some shit",
	"Neutral zone problem, 2 drinks",
	"Picard looks out the window in his Ready Room",
	"Picard runs, 2 drinks",
	"Picard says \"Captain's Log\"",
	"Picard says \"Make it so\"",
	"Picard says \"Number One\"",
	"Q appears in the episode, 2 drinks",
	"Riker does the \"Riker Lean\"",
	"Riker says \"First Officer's Log\"",
	"Saucer Section separation, 2 drinks",
	"Troi has a vision or dream",
	"Troi senses something or uses telepathy",
	"Warp Core Meltdown (or threat of a meltdown), 2 drinks",
	"Worf says \"Honor\""
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/assets/drinking-rules.yaml
// module id = 27
// module chunks = 0